import React from "react";
import { Input, InputNumber, Form } from "antd";
// import "./TextInput.css";

export const TextInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    type,
    disabled,
    validation,
    addonAfter,
    tabIndex,
    onChange,
    maxLength,
    bordered,
    placeholder,
    value,
    defaultValue,
    style,
    onBlur,
    className,
    suffix,
  } = props;
  return (
    <FormItem
      name={name}
      label={title}
      rules={validation}
      className={className}
    >
      <div>
        {type === "password" ? (
          <Input.Password
            name={name}
            value={value}
            tabIndex={tabIndex}
            defaultValue={defaultValue}
            onChange={onChange}
            addonAfter={addonAfter}
            placeholder={placeholder}
            suffix={suffix}
          />
        ) : (
          <Input
            style={style}
            name={name}
            type={"text"}
            value={value}
            bordered={bordered ?? true}
            placeholder={placeholder}
            addonAfter={addonAfter}
            defaultValue={defaultValue}
            tabIndex={tabIndex}
            disabled={disabled}
            maxLength={maxLength}
            onChange={onChange}
            onBlur={onBlur}
            suffix={suffix}
          />
        )}
      </div>
    </FormItem>
  );
};

export const NumberInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    minValue,
    maxValue,
    tabIndex,
    validation,
    onChange,
    placeholder,
    value,
    maxLength,
    style,
    disabled,
    suffix,
  } = props;

  return (
    <FormItem name={name} rules={validation} label={title}>
      <div>
        <Input
          precision="number"
          type="number"
          min={minValue}
          max={maxValue}
          tabIndex={tabIndex}
          id={name}
          value={value}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          style={style}
          disabled={disabled}
          suffix={suffix}
        />
      </div>
    </FormItem>
  );
};

export default TextInput;
